module.exports = __webpack_public_path__ + "static/project-3-2-abae091356e1aed1477a04c94ce395fe.jpg";